export default function SectionHeader({
  title,
  subtitle,
  accent,
}: {
  title: string;
  subtitle?: string;
  accent?: boolean;
}) {
  return (
    <div className="mb-6 flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
          {accent && <span className="h-5 w-1.5 rounded-full bg-accent-500"></span>}
          {title}
        </h2>
        {subtitle && (
          <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
        )}
      </div>
    </div>
  );
}